import WeekSelector from "./WeekSelector";
import WeekView from "./WeekView";
import TimeCodeSelector from "./TimeCodeSelector";
import {AddNewTimecode, UpdateTimesheetLocalState} from '../../services/TimesheetDataService';
import './Timesheet.css'
import MobileDayTotals from "./MobileDayTotals";
import MonthlyReview from "./MonthlyReview";
import {useGlobalStatus} from '../../services/GlobalStatusProvider';
import ExportToCSV from '../ExportToCSV';


export default function Timesheet(props) {   
  const{isDesktop}= useGlobalStatus();
   
  const handleTimecodeAdd = (currentWeekStart, client, project, budget, timecode, userDetails, existingTimecode)=> {      
    var updated = AddNewTimecode(currentWeekStart, [...props.timesheetData], client, project, budget, timecode, userDetails, existingTimecode);
    props.setTimesheetData(updated);  
  }

  const handleEntryCellAction=(data, day)=>{
    var updated = UpdateTimesheetLocalState(props.timesheetData, data, day);
    props.setTimesheetData(updated);  
  }

  const handleWeekChange=(currentWeekStart, client, project, budget, timecode, userDetails, existingTimecode)=> {      
    var updated = AddNewTimecode(currentWeekStart, [...props.timesheetData], client, project, budget, timecode, userDetails, existingTimecode);
    props.setTimesheetData(updated);  
  }
  
  return (
    <>
        <WeekSelector setTimesheetData={props.setTimesheetData} leaveData={props.leaveData} setLeaveData={props.setLeaveData} handleWeekChange={handleWeekChange} handleTimecodeAdd={handleTimecodeAdd} timesheetData={props.timesheetData} timesheetStatusMessage={props.timesheetStatusMessage} setTimesheetStatusMessage={props.setTimesheetStatusMessage}/>
        <div className="approver-section">
          <div>
            <TimeCodeSelector handleTimecodeAdd={handleTimecodeAdd} existingData={props.timesheetData}/>
            <MonthlyReview timesheetData={props.timesheetData}></MonthlyReview>
            
          </div>
          

          <WeekView timesheetData={props.timesheetData} leaveData={props.leaveData} handleEntryCellAction={handleEntryCellAction}/>    
          <br/>
          {!isDesktop && props.leaveData && <MobileDayTotals timesheetData={props.timesheetData} leaveData={props.leaveData}/>}
          <ExportToCSV email="" type="month" text="Export Month as CSV"></ExportToCSV>
        </div>     
      </>
  );
}